import { render, staticRenderFns } from "./HomeSectionAbout.vue?vue&type=template&id=f7aa3ed2&scoped=true"
import script from "./HomeSectionAbout.vue?vue&type=script&lang=js"
export * from "./HomeSectionAbout.vue?vue&type=script&lang=js"
import style0 from "./HomeSectionAbout.vue?vue&type=style&index=0&id=f7aa3ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7aa3ed2",
  null
  
)

export default component.exports